export var SENTRY_RELEASE = "52df4b01293b5a9dd06f1a7ff9e9510dff1ddb5d";
